import axios from 'axios';

import { logout } from 'reducers/user/actions';

export const axiosProductionURLSetup = () => {
  if (process.env.NODE_ENV === 'production') {
    if (process.env.REACT_APP_ENV === 'STAGING') {
      axios.defaults.baseURL = 'https://ecstaging.herokuapp.com/api';
    } else {
      axios.defaults.baseURL = 'https://api.energycompany.com.br/api';
    }
  }
};

export const axiosTokenSetup = user => {
  if (user.access_token) {
    // only add Authorization header for logged in users, otherwise we get a 401 error trying to decode signature 'null'
    axios.defaults.headers.common.Authorization = `Bearer ${user.access_token}`;
  }
};

export const redirectWhenUnauthorized = store => {
  axios.interceptors.response.use(response => {
    return response;
  }, error => {
    // Check error.response because axios does not send response
    // when canceling pending requests via axios.CancelToken.source().
    const landingPageAddress = '/';
    const NOT_AUTHORIZED_ERROR = 401;
    const PAYMENT_NEEDED_ERROR = 402;
    let destination;

    if (error.response) {
      if (error.response.status === NOT_AUTHORIZED_ERROR) {
        store.dispatch(logout());
        destination = landingPageAddress;
      } else if (error.response.status === PAYMENT_NEEDED_ERROR) {
        store.dispatch(logout());
        destination = '/planos';
      }

      if (destination && window.location.pathname !== landingPageAddress) {
        window.location.href = destination;
      }
    }
    return Promise.reject(error);
  });
};



// WEBPACK FOOTER //
// ./src/config/axios.js